function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.000976562,
  width: 35,
  height: 35,
  rx: 3,
  fill: "#201D2F"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  y1: -0.5,
  x2: 14.8116,
  y2: -0.5,
  transform: "matrix(0.899456 -0.437009 0.899456 0.437009 13.4131 22.0488)",
  stroke: "#F0F0F5"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  y1: -0.5,
  x2: 14.8116,
  y2: -0.5,
  transform: "matrix(0.899456 -0.437009 0.899455 0.437009 9.1499 19.9775)",
  stroke: "#F0F0F5"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  y1: -0.5,
  x2: 14.8116,
  y2: -0.5,
  transform: "matrix(0.899456 0.437009 -0.899456 0.437009 8.61719 15.576)",
  stroke: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  y1: -0.5,
  x2: 14.8116,
  y2: -0.5,
  transform: "matrix(0.89946 0.437007 -0.89946 0.437007 12.8799 13.5047)",
  stroke: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 5.96046e-8,
  y: -0.437008,
  width: 13.8116,
  height: 13.8116,
  rx: 0.5,
  transform: "matrix(-0.899458 -0.437008 0.899458 -0.437008 18.0693 23.492)",
  stroke: "#F0F0F5"
});

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.c7a6bd7e.svg";
export { ForwardRef as ReactComponent };